import { createContext, useContext } from 'react';

export interface RegistrationData {
  name: string;
  surname: string;
  email: string;
  username: string;
  password: string;
}

export interface AuthResponse {
  token?: string;
  user?: {
    id: string;
    username: string;
    is_staff: boolean;
  };
  message?: string;
}

export interface AuthContextType {
  isAuthenticated: boolean;
  username: string | null;
  user: {
    id: string;
    username: string;
    is_staff: boolean;
  } | null;
  loading: boolean;
  login: (username: string, password: string) => Promise<AuthResponse>;
  logout: () => Promise<void>;
  register: (data: RegistrationData) => Promise<AuthResponse>;
  verifyEmail: (token: string) => Promise<void>;
  resendVerificationEmail: (email: string) => Promise<void>;
  updateProfile: () => Promise<void>;
  updateNotificationPreferences: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 